var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconReceive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-2h20v20H-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16 0c-.116 0-.116 1.333 0 4a1 1 0 0 1-2 0V2H2v2a1 1 0 0 1-2 0V0c0 .125 5.333.125 16 0zM8 4a1 1 0 0 1 1 1v2h2a1 1 0 0 1 0 2H9v2a1 1 0 0 1-2 0V9H5a1 1 0 0 1 0-2h2V5a1 1 0 0 1 1-1zm7 7a1 1 0 0 1 1 1v4c0-.125-5.333-.125-16 0 .116 0 .116-1.333 0-4a1 1 0 0 1 2 0v2h12v-2a1 1 0 0 1 1-1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReceive);
export default __webpack_public_path__ + "static/media/icon-receive.378e0d5002c0e17cc5719b972dc31eb7.svg";
export { ForwardRef as ReactComponent };